module.exports = __webpack_public_path__ + "img/sdk-0-2.00c9db6.svg";